export const livelandingPageClickTypes = {
  VIDEO_CARD_BUTTON_CLICK: "video_card_button_click",
} as const;

export const __LIVE_LANDING_PAGE__ = "__LIVE_LANDING_PAGE__" as const;

export const livelandingPageComponents = {
  VIDEO_GRID: "video_grid",
  LIVE_SESSIONS: "live_sessions",
  UPCOMING_LIVE_SESSION: "upcoming_live_session",
  PREVIOUSLY_LIVE_SESSION: "previously_live_session",
  PLAYLIST: "playlist",
  LIVE_PLAYLIST: "live_playlist",
  EXPLORE_TOP_PRODUCTS: "explore_top_products",
  VIDEO_CARD: "video_card",
  CAROUSEL_TILES_ENGAGEMENT: "carousel_tiles_engagement",
  CAROUSEL_TILES: "carousel_tiles",
  SEARCH_BAR: "search_bar",
  BOTTOM_NAVIGATION: "bottom_navigation",
  FOOTER: "footer",
  TOP_NAVIGATION_BAR_HEADER: "top_navigation_bar_header",
  SCREEN_BACK: "screen_back",
  READ_MORE: "Read more",
  SHOW_MORE: "Show more",
  SHOW_LESS: "Show less",
} as const;

export const livelandingPageEventNames = {
  LIVE_COMMERCE_PAGE_CLICKED: "LIVE_COMMERCE_PAGE_CLICKED",
  SOCIAL_COMMERCE_CLICKED: "SOCIAL_COMMERCE_CLICKED",
} as const;

export const livelandingPageEventTypes = {
  CLICK: "click",
} as const;

export const livelandingPageJourneyNames = {
  LIVE_COMMERCE: "LIVE_COMMERCE",
  LIVE_LANDING: "LIVE_LANDING",
} as const;

export const livelandingPageNames = {
  LIVE_LANDING_PAGE: "live-page",
  LIVE_COMMERCE_CLP: "LIVE_COMMERCE_CLP",
} as const;

export const livelandingPagePropertyTypes = {
  CLP: "clp",
} as const;

export const livelandingPageReferenceIds = {
  VIDEO_GRID: "video_grid",
  LIVE_SESSIONS: "live_sessions",
  OTHER_LIVE_SESSIONS: "other_live_sessions",
  UPCOMING_LIVE_SESSIONS: "upcoming_live_sessions",
  PREVIOUSLY_LIVE_SESSIONS: "previously_live_sessions",
  BLOCKBUSTER_FRIDAYS: "blockbuster_fridays",
  SHOP_ON_EMI: "shop_on_emi",
  LOANS: "loans",
  INVESTMENTS: "investments",
  TRENDING_NOW: "trending_now",
  EXPLORE_TOP_PRODUCTS: "explore_top_products",
  CAROUSEL_TILES_ENGAGEMENT: "carousel_tiles_engagement",
  RECENT_LIVE_VIDEOS: "recent_live_videos",
  VIDEO_POPUP: "video_pop_up",
  FEATURED_VIDEOS: "featured_videos",
  UPCOMING_LIVE: "upcoming_live",
  PRODUCT_VIDEOS: "product_videos",
  SEARCH_BAR: "search_bar",
  BOTTOM_NAVIGATION: "bottom_navigation",
  FOOTER: "footer",
  TOP_NAVIGATION_BAR_HEADER: "top_navigation_bar_header",
  SCREEN_BACK: "screen_back",
} as const;
